const initailState = {
    singleFile:null
  };
  
  export function singleUrlReducer(state = initailState, { type, payload }) {
  
    switch (type) {
      case "SINGLE_FILE_URL":
        return { ...state ,singleFile:payload};
  
      default:
        return state;
    }
  }